import React from 'react';

class ItemTabBar extends React.Component {

    constructor(props) {
      super(props);
      this.indexToTab = {
        'subscribed':['timeline','details','client','tarifs','documents','emaillist','comparateurs'],
        'devis':['timeline','details','client','tarifs','emaillist','comparateurs'],
        'tarif':['comparateurs','details','tarifs'],
        'error':['comparateurs','details','tarifs']
      }
    }

    selected() {
        return this.indexToTab[this.props.type].indexOf(this.props.tab)
    }

    classAtIndex(i) {
        return ( i==this.selected() )?' tab_item_selected':''
    }

    onClick(i) {
        if ( i != this.selected() ) {
            this.props.container.setTab(this.indexToTab[this.props.type][i]) 
        }
    }

    render() {
        const {container,operator,hasValidSolly} = this.props
        switch ( this.props.type ) {
            case 'tarif':
                return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openComparateurs.bind(container)}>
                        Données comparateurs
                    </div>
                    <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                        Détails
                    </div>
                    <div className={'tab_item'+this.classAtIndex(2)} onClick={container.openTarifs.bind(container)}>
                        Tarifs
                    </div>
                </div>
            case 'devis':
                    return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openTimeline.bind(container)}>
                        Suivi
                    </div>
                    <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                        Détails
                    </div>
                    {this.props.showClient?<div className={'tab_item'+this.classAtIndex(2)} onClick={container.openClient.bind(container)}>
                        {operator ? 'Formulaire souscription' : 'Formulaire Eco By Assurbonplan'}
                    </div>:''}
                    {(operator||!hasValidSolly)?<></>:<div className="tab_item" onClick={container.openSolly.bind(container)}>
                        Formulaire Assurbonplan
                    </div>}
                    <div className={'tab_item'+this.classAtIndex(3)} onClick={container.openTarifs.bind(container)}>
                        Tarifs
                    </div>
                    <div className={'tab_item'+this.classAtIndex(4)} onClick={container.openEmailList.bind(container)}>
                        Autres devis
                    </div>
                    <div className={'tab_item'+this.classAtIndex(5)} onClick={container.openComparateurs.bind(container)}>
                        Données comparateurs
                    </div>
                </div>
            case 'subscribed':
                return <div className='tab_container'>
                <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openTimeline.bind(container)}>
                    Suivi
                </div>
                <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                    Détails
                </div>
                {this.props.showClient?<div className={'tab_item'+this.classAtIndex(2)} onClick={container.openClient.bind(container)}>
                    {operator ? 'Formulaire souscription' : 'Formulaire Eco By Assurbonplan'}
                </div>:''}
                <div className={'tab_item'+this.classAtIndex(3)} onClick={container.openTarifs.bind(container)}>
                    Tarifs
                </div>
                <div className={'tab_item'+this.classAtIndex(4)} onClick={container.openDocuments.bind(container)}>
                    Documents
                </div>
                <div className={'tab_item'+this.classAtIndex(5)} onClick={container.openEmailList.bind(container)}>
                    Autres devis
                </div>
                <div className={'tab_item'+this.classAtIndex(6)} onClick={container.openComparateurs.bind(container)}>
                        Données comparateurs
                </div>
            </div>
            case 'error':
                return <div className='tab_container'>
                    <div className={'tab_item'+this.classAtIndex(0)} onClick={container.openComparateurs.bind(container)}>
                        Données comparateurs
                    </div>
                    <div className={'tab_item'+this.classAtIndex(1)} onClick={container.openDetails.bind(container)}>
                        Détails
                    </div>
                    <div className={'tab_item'+this.classAtIndex(2)} onClick={container.openTarifs.bind(container)}>
                        Tarifs
                    </div>

                </div>
        }
    }
}

export default ItemTabBar;